module.exports = __webpack_public_path__ + "static/group-image-836c304708c8d1aa0c00aee66e68b0c2.png";